import { createApi } from '@reduxjs/toolkit/query/react'
import { url } from 'inspector'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const ProfileAPI = createApi({
  reducerPath: 'ProfileAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Profile'],
  endpoints: builder => ({
    postChangePassword: builder.mutation({
      query: body => ({
        url: `/change-password`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Profile'],
    }),
    getProfile: builder.query({
      query: url => ({
        url: `/${url}/details`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['Profile'],
    }),
    updateProfile: builder.mutation({
      query: data => ({
        url: `/${data.url}/details`,
        method: 'PUT',
        headers: authHeaderAPI(),
        body: data.body,
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
})

export const { usePostChangePasswordMutation, useGetProfileQuery, useUpdateProfileMutation } =
  ProfileAPI
